import React from "react";
import { ActionProps } from "react-querybuilder";
import { Button } from "@nuorder/components";
import { formatMessage } from "lib/globalize-util";
import { DATATEST } from "constants/integration";

export const CustomAddRuleAction: React.FC<ActionProps> = ({ handleOnClick, ...props }) => {
    const handleScrollToBottom = () => {
        const scrollContainerElement = document.querySelector(".queryBuilder");

        if (scrollContainerElement) {
            process.nextTick(() => {
                const bottom = scrollContainerElement.scrollHeight;
                scrollContainerElement.scrollTo(0, bottom);
            });
        }
    };

    const handleClick = React.useCallback(
        (event) => {
            handleOnClick(event);
            handleScrollToBottom();
        },
        [handleOnClick]
    );
    return (
        <Button
            data-test={DATATEST.ASSORTMENTS.DIMENSIONS_FILTER.ADD_FILTER}
            {...props}
            onClick={handleClick}
            iconProps={{ iconName: "plus18" }}
        >
            {formatMessage("Add filter")}
        </Button>
    );
};
